/* 
 * React component that displays when a user clicks on an existing booking. 
 */

import React, {useState, useEffect}     from 'react'

import {LoadingIndicator}               from '../../lib/iprs-react-library/src/index.js';
import {Cancel}                         from '../../lib/iprs-react-library/src/index.js';
import BookingSummary                   from '../Booking/BookingSummary'
import useBookingState, {B_ACTIONS}     from '../Booking/bookingReducer'

import BookingData                      from '../Booking/BookingData'

const BookingOverlay = ({api, selectInfo, done, setError, state, 
    eventDispatch}) => {
    
    const [loading, setLoading]             = useState(''); 
    
    const { extendedProps: { apiEvent: { BookingID: bookingID} = {} } = {} }    = selectInfo
            
    // extract appointment types which we store in the application state
    const { appType: { appointmentTypes = [] } = {} }                = state;
    
    const [booking, setBooking]                         = useState(null) 
    
    const [,bookingDispatch]               = useBookingState( state, eventDispatch )
    
    useEffect( 
        () => {
            setError( null );
            setLoading(true);
            api.getBooking( bookingID )
            .then( r => { 
                const bd = new BookingData()
                bd.loadFromAPI( r.apiResult, appointmentTypes );
                setBooking( bd );
                setLoading(false);
            } )
            .catch( err => { 
                setError( err.message );
                setLoading(false); 
            } )
        },
    [bookingID, api, appointmentTypes, setError] );
    
    const handleReschedule = e => {
        e.preventDefault()
        bookingDispatch( B_ACTIONS.RESCHEDULE, booking )
    }
    
    const handleDelete = e => {
        e.preventDefault()
        bookingDispatch( B_ACTIONS.DELETE, booking )
    }
    
    const handleUpdateDescription = e => {
        e.preventDefault()
        bookingDispatch( B_ACTIONS.DESCRIPTION_EDIT, booking )
    }
    
    return (<>
        <div>
            <button onClick={handleDelete} >Delete</button>
            <button onClick={handleReschedule} >Reschedule</button>
            <button onClick={handleUpdateDescription} >Edit</button>
        </div>
        
        <LoadingIndicator loading={loading} />
        
        <BookingSummary booking={booking} />
        
        <Cancel onCancel={done} cancelText='Done' />
    </>)
}



export default BookingOverlay

